export const SET_PROJECTS_LIST = 'SET_PROJECTS_LIST';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_PERMISSION_GROUPS = 'SET_PERMISSION_GROUPS';
export const SET_PERMISSION_AVAILABLE_ROLES = 'SET_PERMISSION_AVAILABLE_ROLES';
export const SET_PERMISSION_AVAILABLE_PROJECTS = 'SET_PERMISSION_AVAILABLE_PROJECTS';
export const SET_PERMISSION_PRIORITY = 'SET_PERMISSION_PRIORITY';
